import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function VerumdbiContentReducer(state = initialState.verumdbiContent, action: any) {
  switch (action.type) {

    case types.SAVE_VERUMDBICONTENT_SUCCESS:
      return action.verumdbiContent;

    default:
      return state;
  }
}
